<div *ngFor="let portlet of portlets$ | async">
  <div [innerHTML]="portlet.html"></div>
</div>
